import JocCard from '../JocCard';
import styles from './llistatJocs.module.scss';

const LlistatJocs = (props) => {
    const { items } = props;

    return items ? (
        <div className={styles.containerCards}>
            {items?.map((item) => {
                return (
                    <div key={item.slug || item.href}>
                        <JocCard
                            imatgeSrc={item.imatgeSrc}
                            titol={item.titol}
                            descripcio={item.descripcio}
                            href={item.href}
                            novaFinestra={item.novaFinestra}
                            alt={item.alt}
                            linkTipus={item.linkTipus}
                            slug={item.slug}
                            textBoto={item.textBoto}
                        />
                    </div>
                );
            })}
        </div>
    ) : (
        <></>
    );
};

export default LlistatJocs;
